<template>
  <section class="margin-bottom-xl">
    <div class="section-header margin-bottom-s">
      <h3>{{ CREDIT_CARD.heading }}</h3>
    </div>
    <div v-if="creditCards === null" class="grid-x">
      <Skeleton height="237px" />
    </div>
    <div v-else :class="getCreditCards.length === 0 ? 'acc-sect-wrapper' : 'margin-top-s'">
      <template v-if="creditError.notification.message && !isMaintenanceAlert">
        <Notification :severity="creditError.notification.type" :closable="false" :class="!isTypeError ? 'margin-bottom-s' : ''">
          <div>
            <div v-if="isTypeError" class="notification-heading">
              {{ notificationHeading }}
            </div>
            <div class="notification-text">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <p>
                <span v-if="creditError.notification.headLine" class="heavy" v-html="sanitize(creditError.notification.headLine)"></span>
                <span v-else class="heavy">{{ creditError.notification.title }}</span>
                <br />
                <span v-html="sanitize(creditError.notification.message)"></span>

                <CitiRedirectLink
                  v-if="creditError.notification.url"
                  :css="['summary-links', 'link-med']"
                  :action="'dashboard'"
                  :fire-tag-link="'credit summary'"
                >
                  <template #citi-link-content>
                    {{ creditError.notification.urlTitle }}
                  </template>
                </CitiRedirectLink>
              </p>
            </div>
          </div>
        </Notification>
      </template>

      <template v-if="!isTypeError">
        <template v-if="getCreditCards.length === 0">
          <ClientOnly v-if="killSwitches?.cardActivationEnhancementsEnabled && killSwitches?.cardActivationEnhancementsMyAccountEnabled">
            <CreditcardBannerConsumableCreditCardBanner
              source="myaccount"
              :card-activation-enhancements-enabled="
                killSwitches?.cardActivationEnhancementsEnabled && killSwitches?.cardActivationEnhancementsMyAccountEnabled
              "
              :credit-new-account-discount-enabled="killSwitches?.creditNewAccountDiscountEnabled"
              :credit-banner-discount-payload="discountPayload"
              bringback-page="myAccount"
            />
          </ClientOnly>
          <EmptyCreditCard v-else />
        </template>
        <Carousel v-else :list="getCreditCards">
          <template #item="slotProps">
            <PaymentCard :card="slotProps.data" :index="slotProps.index" />
          </template>
        </Carousel>
      </template>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import Carousel from '@atomic-ui/carousel/Carousel';
import Notification from '@atomic-ui/notification/Notification';
import Skeleton from '@atomic-ui/skeleton/Skeleton';
import { CREDIT_CARD, brand } from 'config';
import { sanitize } from '@vue-util/sanitize';
import PaymentCard from './PaymentCard';
import CitiRedirectLink from '../citiRedirect/CitiRedirectLink';
import EmptyCreditCard from './EmptyCreditCard';
import { useWalletStore } from '~/stores/useWalletStore';
import { useEnvPropsStore } from '~/stores/useEnvPropsStore';

const walletStore = useWalletStore();
const envPropsStore = useEnvPropsStore();

const { creditCards, getCreditCards, creditError } = storeToRefs(walletStore);
const { killSwitches, deviceType } = storeToRefs(envPropsStore);

const notificationHeading = computed(() => creditError.value.notification.title || CREDIT_CARD.serviceInterruptionTitle);
const isTypeError = computed(() => creditError.value.notification.type === 'error');
const isMaintenanceAlert = computed(() => CREDIT_CARD.maintenanceAlertTitle === creditError.value.notification.title);

const discountPayload = computed(() => ({
  originInfo: {
    division: brand === 'mcom' ? 'MACYS' : 'BLOOMINGDALES',
    deviceType: deviceType.value,
  },
}));
</script>
